import { i18n } from '@/locales';
import { isRequired } from './index';
export const createRequestMapFormRule = () => ({
    /** 지역선택 */
    areaType: [
        (v) => v !== null || i18n.t('form_rules.value_require'),
    ],
    /** 읍면동 */
    eupMyeonDong: [
        (v) => isRequired(v) || i18n.t('form_rules.value_require'),
    ],
    /** 주번 */
    mainLotNumber: [
        (v) => isRequired(v) || i18n.t('form_rules.value_require'),
    ],
    /** 세부명칭 */
    buildingName: [
        (v) => isRequired(v) || i18n.t('form_rules.value_require'),
    ],
    /** 행정동(특수지명) */
    administrativeArea: [
        () => true,
    ],
    /** 선택한 주소가 없습니다. 주소를 선택해 주세요. */
    isSelectedAddress: [
        (v) => v !== null,
    ],
});
